<template>
  <main class="adm-wrap">
    <div class="adm-inner">

      <div class="adm-page-title">호텔 추가안내 템플릿 관리</div>

      <div class="adm-toolbar">
        <button type="button" class="adm-btn adm-btn--primary" @click="goToInsert">
          + 추가안내 등록
        </button>
      </div>

      <table class="adm-table">
        <colgroup>
          <col style="width: 160px;">
          <col style="width: 120px;">
          <col>
          <col style="width: 220px;">
          <col style="width: 80px;">
          <col style="width: 80px;">
        </colgroup>
        <thead>
          <tr>
            <th class="text-center">안내 코드</th>
            <th class="text-center">사용여부</th>
            <th>안내 제목</th>
            <th class="text-center">적용 기간</th>
            <th class="text-center">수정</th>
            <th class="text-center">상태변경</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="addInfoList.length === 0">
            <td colspan="6" class="adm-empty">등록된 추가안내 템플릿이 없습니다.</td>
          </tr>
          <tr v-for="(item, i) in addInfoList" :key="i">
            <td class="text-center adm-code">{{ item.addInfoCode }}</td>
            <td class="text-center">
              <span :class="item.addUseFlag === 'Y' ? 'adm-badge adm-badge--on' : 'adm-badge adm-badge--off'">
                {{ item.addUseFlag === 'Y' ? '사용중' : '미사용' }}
              </span>
            </td>
            <td>
              <a class="adm-link" @click="goToEdit(item.addInfoCode)">
                {{ item.addTitle }}
              </a>
            </td>
            <td class="text-center adm-period">
              {{ item.addUseStart ? item.addUseStart.slice(0,10) : '-' }}
              ~
              {{ item.addUseClose ? item.addUseClose.slice(0,10) : '-' }}
            </td>
            <td class="text-center">
              <button type="button" class="adm-btn adm-btn--sm adm-btn--sub"
                @click="goToEdit(item.addInfoCode)">수정</button>
            </td>
            <td class="text-center">
              <button type="button"
                :class="item.addUseFlag === 'Y' ? 'adm-btn adm-btn--sm adm-btn--warn' : 'adm-btn adm-btn--sm adm-btn--primary'"
                @click="changeStatus(item.addUseFlag, item.addInfoCode)">
                {{ item.addUseFlag === 'Y' ? '중지' : '활성' }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </main>
</template>

<script>
export default {
  name: 'RakutenAddInfoList',

  data() {
    return {
      addInfoList: [],
    };
  },

  computed: {
    user() { return this.$store.state.user; },
  },

  created() {
    this.getAddInfoList();
  },

  mounted() {
    if (this.user.handlerGrade >= 20) {
      this.$swal.fire({ title: '접근 불가', icon: 'error' });
      this.$router.push({ path: '/' });
    }
    document.getElementById('user').style.display = 'none';
  },

  methods: {
    async getAddInfoList() {
      const result = await this.$api('/api/rakutenAddInfoList', {});
      this.addInfoList = Array.isArray(result) ? result : [];
    },

    goToInsert() {
      this.$router.push({ path: '/ma_AddInfoCreate'});
    },

    goToEdit(addInfoCode) {
      this.$router.push({ path: '/ma_AddInfoCreate', query: { aICode: addInfoCode } });
    },

    changeStatus(currentFlag, addInfoCode) {
      const newFlag = currentFlag === 'Y' ? 'N' : 'Y';
      const msg = newFlag === 'Y' ? '이 템플릿을 <b>활성화</b>할까요?' : '이 템플릿을 <b>미사용</b>으로 변경할까요?';

      this.$swal.fire({
        title: '상태 변경',
        html: msg,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '변경',
        cancelButtonText: '취소',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const res = await this.$api('/api/rakutenAddInfoStatusUpdate', {
            param: [newFlag, this.user.handlerId, addInfoCode]
          });
          if (res?.affectedRows >= 1) 
          {
            this.$swal.fire('', '변경완료!', 'success');
            this.getAddInfoList();
          } 
          else 
          {
            this.$swal.fire('', '변경실패', 'error');
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.adm-wrap {
  padding: 28px 20px 60px;
  background: #f5f5f5;
  min-height: 100vh;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 1rem;
  color: #222;
}
.adm-inner {
  max-width: 1100px;
  margin: 0 auto;
}
.adm-page-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid #222;
}
.adm-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

/* 테이블 */
.adm-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border: 1px solid #d0d0d0;
}
.adm-table th,
.adm-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #e8e8e8;
  vertical-align: middle;
  font-size: 13px;
}
.adm-table thead th {
  background: #f0f0f0;
  font-weight: 700;
  color: #333;
  white-space: nowrap;
}
.adm-table tbody tr:hover { background: #fafff5; }
.adm-table tr:last-child td { border-bottom: none; }

.text-center { text-align: center; }
.adm-empty { text-align: center; color: #aaa; padding: 40px 0; }
.adm-code { font-size: 12px; color: #888; font-family: monospace; }
.adm-period { font-size: 12px; color: #555; }

/* 링크 */
.adm-link {
  color: #1a73e8;
  cursor: pointer;
  font-weight: 500;
}
.adm-link:hover { text-decoration: underline; }

/* 뱃지 */
.adm-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
}
.adm-badge--on  { background: #e8f5e9; color: #2e7d32; }
.adm-badge--off { background: #f5f5f5; color: #999; }

/* 버튼 */
.adm-btn {
  height: 34px;
  padding: 0 20px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  border: 1px solid transparent;
}
.adm-btn--sm { height: 28px; padding: 0 12px; font-size: 12px; }
.adm-btn--primary { background: #86cd53; color: #fff; border-color: #6ab840; }
.adm-btn--primary:hover { background: #6ab840; }
.adm-btn--sub { background: #fff; color: #555; border-color: #bbb; }
.adm-btn--sub:hover { background: #f0f0f0; }
.adm-btn--warn { background: #fff3e0; color: #e65100; border-color: #ffb74d; }
.adm-btn--warn:hover { background: #ffe0b2; }
</style>